# ---
# Авторесайз тела модального окна
# Для корректной работы необходимо добавить класс recalculated-body к modal-body
# ---

module.exports = App.RecalculateModalBodyMixin = Ember.Mixin.create
  recalculateLayout: ->
    return if @get('isDestroyed')

    headerH = @$('.modal-header').outerHeight()
    footerH = @$('.button-block').outerHeight()

    fullH = $(window).height()

    PADDING = 20
    @$('.modal-body.recalculated-body').css('max-height': fullH - headerH - footerH - 2 * PADDING)

  bindedRecalculateLayout: (->
    => Em.run.debounce @, @recalculateLayout, 150
  ).property()

  registerAlignHandler: (->
    @recalculateLayout()
    Em.$(window).on 'resize', @get('bindedRecalculateLayout')
  ).on('didInsertElement')

  removeAlignHandler: (->
    Em.$(window).off 'resize', @get('bindedRecalculateLayout')
  ).on('didInsertElement')